<template>
  <sidebar-row border-bottom>
    <template #actionIcon>
      <v-icon :color="attachment.iconColor" style="font-size: 28px">
        {{ attachment.icon }}
      </v-icon>
    </template>

    <v-row no-gutters class="py-4">
      <v-col>
        <v-tooltip
          left
          content-class="pa-0"
          color="rgba(255,255,255,0)"
          :disabled="!attachment.is_photo"
          :allow-overflow="true"
        >
          <template #activator="{ on }">
            <p
              class="ma-0 pl-1"
              style="text-align: left; font-size: 12px; line-height: 14px; font-weight: normal; color: #202124"
              v-on="on"
            >
              {{ attachment.name }}
            </p>
          </template>
          <img :src="attachment.thumbnailUrl" :alt="attachment.name" />
        </v-tooltip>
        <italic-subheader
          class="pl-1"
          :straight-text="attachment.subheader"
          style="font-size: 10px !important;"
        ></italic-subheader
      ></v-col>
      <v-col cols="1">
        <dots-menu
          :items="attachment.dotsItems"
          @setProfileImage="toggleProfileImageDialog(true)"
          @delete="openDialog(attachment)"
          @download="downloadAttachment(attachment.id)"
          font-size="18px"
        >
        </dots-menu>
      </v-col>
    </v-row>
    <main-input-dialog
      v-if="profileImageDialogLoaded"
      :is-visible.sync="profileImageDialogVisible"
      :loading="profileImageDialogLoading"
      :title-translation="$i18n.t('dialog.title.setAttachmentsAsProfileImage')"
      agree-text="dialog.agreeSet"
      dialog-width="30%"
      @agree="setProfileImage"
      :inputs="profileImageDialogInputs"
    >
      <template #attribute.input="data">
        <v-col cols="6">
          <data-input v-model="profileImageAttribute" v-bind="data" />
        </v-col>
      </template>
    </main-input-dialog>
  </sidebar-row>
</template>

<script>
import { call, get } from 'vuex-pathify';
import prepareAttributesFeatureCardMixin from '@/mixins/prepareAttributesFeatureCardMixin';
import ItalicSubheader from '@/components/ItalicSubheader';
import DotsMenu from '@/components/DotsMenu';
import SidebarRow from '@/components/SidebarRow';
import DataInput from '@/components/DataInput';

export default {
  name: 'TheAttachment',
  components: {
    SidebarRow,
    ItalicSubheader,
    DotsMenu,
    MainInputDialog: () => import('@/components/MainInputDialog'),
    DataInput,
  },
  mixins: [prepareAttributesFeatureCardMixin],
  props: {
    attachment: {
      type: Object,
      required: true,
    },
    layerId: {
      type: [String, Number],
      required: true,
    },
    featureId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    currentLayer: get('layers/layers@:layerId'),
    currentLayerAttributes() {
      return this.$_flattenStructure(this.currentLayerFormSchema || []);
    },
    currentLayerImageAttributes() {
      return this.currentLayerAttributes
        .filter(attribute => this.currentLayer.image_attributes.includes(attribute.attribute))
        .map(attribute => {
          return { text: attribute.label, value: attribute.attribute };
        });
    },
    profileImageDialogInputs() {
      return [
        {
          name: 'attribute',
          translationPath: 'dialog.imageProfileAttribute',
          dataType: {
            name: 'select',
          },
          items: this.currentLayerImageAttributes,
          cols: '12',
          rules: [v => !!v || v == '0' || 'rules.required'],
        },
      ];
    },
  },
  data: () => ({
    profileImageDialogLoaded: false,
    profileImageDialogVisible: false,
    profileImageDialogLoading: false,
    profileImageAttribute: '',
  }),
  methods: {
    downloadAttachment: call('relations/downloadAttachment'),
    editDatasourceFeature: call('layers/editDatasourceFeature'),
    openDialog(file) {
      this.$emit('deleteFile', file);
    },
    toggleProfileImageDialog(value = !this.profileImageDialogVisible) {
      if (value) this.profileImageDialogLoaded = value;
      this.profileImageDialogVisible = value;
    },
    async setProfileImage(attribute = this.profileImageAttribute) {
      this.profileImageDialogLoading = true;
      try {
        await this.editDatasourceFeature({
          datasource: this.currentLayer.data_source_name,
          id: this.featureId,
          body: {
            [attribute]: this.attachment.fileRelativeUrl,
          },
          params: { layer_id: this.currentLayer.id },
        });
        this.$root.$emit('refreshTableData');
        this.$root.$emit('refreshFormData');
        this.profileImageDialogVisible = false;
      } finally {
        this.profileImageDialogLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
